import React from "react";
import strings from "../../helpers/Localization";
import TagChip from "./TagChip";
import Modal from "../Modal/Modal";

const AddTags = ({ maxWidth, allTags, elementTags, onChangeTags, onOpenModal, onCloseModal }) => {
    const [tagsModalsOpen, setTagsModalsOpen] = React.useState(false);
    const [tagsToAdd, setTagsToAdd] = React.useState([]);
    const [tagsToCreate, setTagsToCreate] = React.useState([]);
    const [tagsToRemove, setTagsToRemove] = React.useState([]);
    const [newTag, setNewTag] = React.useState("");

    const openModal = () => {
        if (onOpenModal) {onOpenModal();}
        setTagsModalsOpen(true);
    };
    const closeModal = () => {
        if (onCloseModal) {onCloseModal();}
        setTagsModalsOpen(false);
    };

    return <>
        <div className="custom-select-container"
            style={{ maxWidth: maxWidth ? maxWidth + "px" : null, flexGrow: "1", flex: "1", flexShrink: "0", display: "flex",
                alignItems: "center", justifyContent: "flex-start", padding: "0 10px", gap: "10px" }}
        >
            {
                elementTags.map((etag, index) => {
                    return <TagChip
                        key={index}
                        tagName={etag.value}
                        onDelete={() => {
                            onChangeTags([], [], [etag]);
                        }}
                    />;
                })
            }
            <span style={{ display: "flex", flexGrow: "1" }}/>
            <a className="TextContent14" style={{ cursor: "pointer", fontWeight: "500", textDecorationLine: "underline" }}
                onClick={(e) => openModal()}
            >{strings.addTag}</a>
        </div>
        <Modal
            open={tagsModalsOpen}
            onClose={() => closeModal()}
            title={strings.addTag}
            icon={"add"}
            onValidate={() => {
                closeModal();
                const createList = tagsToCreate;
                const addList = tagsToAdd;
                if (newTag && newTag !== "") {
                    const existingTag = allTags.find(t => t.value === newTag);
                    if (existingTag) {
                        if (!elementTags.some(t => t.value === existingTag.value) && !tagsToAdd.some(t => t.value === existingTag.value) && !tagsToRemove.some(t => t.value === existingTag.value)) {
                            addList.push(existingTag);
                        }
                    }
                    else {
                        createList.push({
                            id: 0,
                            value: newTag
                        });
                    }
                }
                onChangeTags(addList, createList, tagsToRemove);
                setTagsToAdd([]);
                setTagsToRemove([]);
                setTagsToCreate([]);
                setNewTag("");
            }}
            fields={[
                {
                    type: "textfield",
                    title: strings.newTag,
                    placeholder: strings.newTag,
                    value: newTag,
                    onChange: (e) => { setNewTag(e.target.value); }
                },
                {
                    type: "custom",
                    title: strings.existingtags,
                    child: <div style={{ display: "flex", flexDirection: "row", flexGrow: "1", flexWrap: "wrap", gap: "10px" }}>
                        {
                            (allTags ? allTags : []).map((tag, index) => {
                                const isSelected = (elementTags && elementTags.some(t => t.value === tag.value)
                            || tagsToAdd.some(t => t.value === tag.value)) && !tagsToRemove.some(t => t.value === tag.value);
                                return <TagChip
                                    key={index}
                                    selected={isSelected}
                                    tagName={tag.value}
                                    onSelect={() => {
                                        if (isSelected) {
                                            if (tagsToAdd.some(t => t.value === tag.value)) {
                                                setTagsToAdd(tagsToAdd.filter(t => t.value !== tag.value));
                                            }
                                            setTagsToRemove([...tagsToRemove, tag]);
                                        }
                                        else {
                                            if (tagsToRemove.some(t => t.value === tag.value)) {
                                                setTagsToRemove(tagsToRemove.filter(t => t.value !== tag.value));
                                            }
                                            setTagsToAdd([...tagsToAdd, tag]);
                                        }
                                    }}
                                />;
                            })
                        }
                    </div>
                }
            ]}
        >
        </Modal>
    </>;
};

export default AddTags;
